import { createReducer } from '@reduxjs/toolkit';
import {
  getHelpOptionsSettings,
  openNovoAIDialog,
  closeNovoAIDialog,
  changeDrawerState,
  askNovoAiRequest,
  getRecentQuestions,
  setVoteLoading,
  setVoteState,
  showVoteFeedback,
  resetVoteState,
  resetState,
} from 'redux/actions/help-options';
import { AskNovoAiDrawerState } from 'institutions/components/ask-novoai/helpers';
import { initialRootState } from './index';

export default createReducer(initialRootState, builder => {
  builder.addCase(resetState.fulfilled, (state) => {
    state.app.askNovoAi = initialRootState.app.askNovoAi;
  });
  builder.addCase(getHelpOptionsSettings.fulfilled, (state, action) => {
    state.app.askNovoAi.helpOptions = action.payload;
  });
  builder.addCase(openNovoAIDialog, (state) => {
    state.app.askNovoAi.isOpen = true;
  });
  builder.addCase(closeNovoAIDialog, (state) => {
    state.app.askNovoAi.isOpen = false;
  });
  builder.addCase(changeDrawerState, (state, payload) => {
    state.app.askNovoAi.drawerState = payload.payload;
  });
  builder.addCase(askNovoAiRequest.fulfilled, (state, { payload }) => {
    state.app.askNovoAi.response = payload;
    if (payload.responseCode === 200 || payload.responseCode === 409) {
      state.app.askNovoAi.drawerState = AskNovoAiDrawerState.SUCCESS;
    } else {
      state.app.askNovoAi.response.answer = '';
      state.app.askNovoAi.drawerState = AskNovoAiDrawerState.ERROR;
    }
  });
  builder.addCase(askNovoAiRequest.pending, (state) => {
    state.app.askNovoAi.drawerState = AskNovoAiDrawerState.LOADING;
  });
  builder.addCase(askNovoAiRequest.rejected, (state) => {
    // Mostly for network errors
    state.app.askNovoAi = {
      ...state.app.askNovoAi,
      drawerState: AskNovoAiDrawerState.ERROR,
      response: {
        questionText: state.app.askNovoAi.question,
        answer: '',
        responseCode: 500,
        referencedComponents: [],
        liveEvents: [],
      },
    };
  });
  builder.addCase(getRecentQuestions.fulfilled, (state, payload) => {
    state.app.askNovoAi.recentQuestions = payload.payload;
  });

  // Vote state handlers
  builder.addCase(setVoteLoading, (state, { payload }) => {
    const { questionId, isLoading } = payload;
    if (!state.app.askNovoAi.voteState[questionId]) {
      state.app.askNovoAi.voteState[questionId] = {
        upvoted: false,
        downvoted: false,
        isLoading: false,
        showFeedback: false,
      };
    }
    state.app.askNovoAi.voteState[questionId].isLoading = isLoading;
  });

  builder.addCase(setVoteState, (state, { payload }) => {
    const { questionId, voteType, voted } = payload;
    if (!state.app.askNovoAi.voteState[questionId]) {
      state.app.askNovoAi.voteState[questionId] = {
        upvoted: false,
        downvoted: false,
        isLoading: false,
        showFeedback: false,
      };
    }

    if (voteType === 'vote_up') {
      state.app.askNovoAi.voteState[questionId].upvoted = voted;
      state.app.askNovoAi.voteState[questionId].downvoted = false;
    } else {
      state.app.askNovoAi.voteState[questionId].downvoted = voted;
      state.app.askNovoAi.voteState[questionId].upvoted = false;
    }
    state.app.askNovoAi.voteState[questionId].isLoading = false;
  });

  builder.addCase(showVoteFeedback, (state, { payload }) => {
    const { questionId, show } = payload;
    if (!state.app.askNovoAi.voteState[questionId]) {
      state.app.askNovoAi.voteState[questionId] = {
        upvoted: false,
        downvoted: false,
        isLoading: false,
        showFeedback: false,
      };
    }
    state.app.askNovoAi.voteState[questionId].showFeedback = show;
  });

  builder.addCase(resetVoteState, (state, { payload }) => {
    const { questionId } = payload;
    state.app.askNovoAi.voteState[questionId] = {
      upvoted: false,
      downvoted: false,
      isLoading: false,
      showFeedback: false,
    };
  });
});
